/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Loadingmembers2Inputs */

const zh_organizationsettings_loadingmembers2 = /** @type {(inputs: Organizationsettings_Loadingmembers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成员加载中...`)
};

const en_organizationsettings_loadingmembers2 = /** @type {(inputs: Organizationsettings_Loadingmembers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading members...`)
};

const es_organizationsettings_loadingmembers2 = /** @type {(inputs: Organizationsettings_Loadingmembers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando miembros...`)
};

/**
* | output |
* | --- |
* | "Loading members..." |
*
* @param {Organizationsettings_Loadingmembers2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_loadingmembers2 = /** @type {((inputs?: Organizationsettings_Loadingmembers2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Loadingmembers2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_loadingmembers2(inputs)
	if (locale === "en") return en_organizationsettings_loadingmembers2(inputs)
	return es_organizationsettings_loadingmembers2(inputs)
});
export { organizationsettings_loadingmembers2 as "organizationSettings_loadingMembers" }